module.exports = __webpack_public_path__ + "static/media/condiciones_equipajes.8ffdfa78.png";